import { Box, useTheme } from '@mui/material';
import InfoSection from '../../../components/InfoSection';
import InfoGalery from '../../../components/InfoGalery';
import { tokens } from '../../../theme/theme';

export const Energieausweis = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const bullets = [
    <span>
      Verbrauchsausweis
      <br />
      <Box className="pl-2 normal-case" fontWeight={400}>
        Basierend auf tatsächlichem Energieverbrauch des Gebäudes
      </Box>
    </span>,
    <span>
      <b>Bedarfsausweis</b>
      <br />
      <Box className="pl-2 normal-case" fontWeight={400}>
        Basierend auf einer technischen Analyse des Gebäudezustands
      </Box>
    </span>,
  ];
  const pictures = [
    {
      webp: '/media/energy/PFLEGER BAUSERVICE ENERGY-02.webp',
      jpg: '/media/energy/PFLEGER BAUSERVICE ENERGY-02.jpg',
    },
    {
      webp: '/media/energy/PFLEGER BAUSERVICE ENERGY FILL.webp',
      jpg: '/media/energy/PFLEGER BAUSERVICE ENERGY FILL.jpg',
      opacity: 0.2,
    },
  ];

  return (
    <Box className="h-full w-full flex flex-col xl:flex-row justify-between items-center p-2 md:p-10 overflow-hidden gap-4">
      <InfoSection
        number={5}
        title="Energieausweis"
        subTitle="Ihre Garantie für ein solides Bauprojekt."
        bulletArray={bullets}
        color={colors.energy[500]}
      />
      <InfoGalery pictures={pictures} />
    </Box>
  );
};
